import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';

import AppDialog from '../../../../../components/common/AppDialog';
import { ILocation } from './Location-utils';
import { useDeleteLocations } from '../../../../../hooks/useLocations';
import { appColors } from '../../../../../theme';

interface Ownprops {
  locations: ILocation;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  open: boolean;
}

const LocationDeleteModal = ({ locations, setOpen, open }: Ownprops) => {
  const { id, name } = locations;

  const data = {
    isDeleted: true,
  };

  const deleteLocation = useDeleteLocations(data, id);

  const handleClose = () => setOpen(false);

  const handleDelete = () => {
    deleteLocation.mutate(data, {
      onSuccess: () => {
        setOpen(false);
      },
    });
  };

  return (
    <AppDialog
      open={open}
      onDialogClose={handleClose}
      title="Are you sure you want to delete?"
      isFormDelete={true}
      maxWidth="xs"
    >
      <Typography textAlign="left" color={appColors.textGray}>
        {`If yes, ${name} will be deleted `}
      </Typography>
      <Stack direction="row" alignItems="center" justifyContent="flex-end" mt={4} mb={2} gap={2}>
        <Button
          variant="contained"
          disableElevation
          sx={{
            textTransform: 'capitalize',
            backgroundColor: appColors.offWhite,
            color: '#2C3078',
            width: 120,
            '&:hover': {
              background: '#E6E6E6',
            },
          }}
          onClick={handleClose}
          disabled={deleteLocation.isLoading}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="error"
          disableElevation
          sx={{
            textTransform: 'capitalize',
            pointerEvents: 'initial',
            width: 120,
          }}
          onClick={handleDelete}
          disabled={deleteLocation.isLoading}
        >
          {deleteLocation.isLoading ? (
            <CircularProgress size={20} color="inherit" />
          ) : (
            'Delete'
          )}
        </Button>
      </Stack>
    </AppDialog>
  );
};

export const LocationDeleteDialog = LocationDeleteModal;
export default LocationDeleteModal;
